<template>
  <div id="post" class="news">
    <h1>{{ $t('news') }}</h1>
    <template v-if="post">
      <div class="date">{{ toDate(post.date_gmt) }}</div>
      <div class="title">{{ post.title.rendered }}</div>
      <div class="news-contents" v-html="post.content.rendered"></div>
    </template>
    <Loader v-else/>
  </div>
</template>

<script>
import dayjs from "dayjs";
import axios from "axios";
import Loader from "@/components/Parts/Loader.vue";
import * as SETTINGS from '../../../settings';

export default {
  data() {
    return {
      post: false
    };
  },

  computed: {},

  beforeMount() {
    this.getPost();
  },

  watch: {
    '$i18n.locale' () {
      this.getPost();
    }
  },

  methods: {
    async getPost() {
      const uri = SETTINGS.API_BASE_PATH + "posts?lang=" + this.$i18n.locale + "&slug=" + this.$route.params.postSlug;
      const response = await axios.get(uri);
      this.post = response.data[0];
    },
    toDate(date) {
      if (this.$i18n.locale === 'ja') {
        return dayjs(date).format("YYYY年M月D日");
      } else {
        return dayjs(date).format("MMMM D, YYYY");
      }
    }
  },

  components: {
    Loader
  }
};
</script>

<style lang="scss" scoped>
@include post;
</style>